<script lang="ts" setup>
import LeButton from "@dsk/components/Button/LeButton.vue";
import LeHeading from "@dsk/components/Heading/LeHeading.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { config } from "@/config";
import { MatomoHelper } from "@/helpers";
import type { Receipt, SimpleProduct } from "@/types";

import LeOrderDetails from "./LeOrderDetails.vue";
import LeSectionHeading from "./LeSectionHeading.vue";

const props = defineProps<{
  receipt: Receipt;
}>();

const { t } = useI18n();

const product = computed<SimpleProduct>(() => ({
  name: props.receipt.items[0].product ?? "",
  price: props.receipt.items[0].price ?? "",
  currency: props.receipt.currency
}));

MatomoHelper.trackEcommerceOrder(
  props.receipt.orderId.toString(),
  parseFloat(props.receipt.totalAmount.replace(/,/, "."))
);
</script>

<template>
  <div class="le-order-status-success">
    <LeSectionHeading :text="t('le-order-status-success.heading')" :progress-active="2" />
    <p class="le-order-status-success__text">{{ t("le-order-status-success.text") }}</p>

    <LeHeading tag="h2" size="s">
      {{ t("le-order-status-success.order-details-heading") }}
    </LeHeading>
    <LeOrderDetails
      v-if="product"
      :username="receipt.username"
      :product="product"
      class="le-order-status-success__order-details"
    />

    <LeHeading tag="h2" size="s">
      {{ t("le-order-status-success.thank-you-heading") }}
    </LeHeading>
    <p class="le-order-status-success__thank-you-text">{{ t("le-order-status-success.thank-you-text") }}</p>
    <LeButton tag="a" size="large" :href="`/${config.app.language}/`" full-width>{{
      t("le-order-status-success.button-text")
    }}</LeButton>
  </div>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";

.le-order-status-success {
  #media-breakpoint-up(lg, {
    max-width: 460px;
  });

  &__text {
    margin-top: 22px;
    margin-bottom: 36px;

    #media-breakpoint-up(lg, {
      margin-top: 6px;
    });
  }

  &__order-details {
    margin-top: 14px;
    margin-bottom: 56px;

    #media-breakpoint-up(lg, {
      margin-top: 6px;
    });
  }

  &__thank-you-text {
    margin-top: 12px;
    margin-bottom: 36px;
  }
}
</style>
